export default {
  description: 'Wklej JSON dla RenderRoot lub pojedynczego elementu renderowania, aby zobaczyc podglad.',
  jsonInputPlaceholder: 'Wklej tutaj JSON RenderRoot lub elementu renderowania',
  validationErrorSummary: 'Podglad niedostepny',
  errors: {
    emptyInput: 'Pole jest puste. Wklej JSON, aby uruchomic podglad.',
    unknownJsonError: 'Nieznany blad parsowania JSON.',
    invalidJson: 'Nieprawidlowa skladnia JSON: {details}',
  },
};
